//@ts-nocheck
import Router, { routingMixin } from "@jack-henry/web-component-router";
import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import "@banno/jha-wc/src/jha-tab/jha-tab";
import "@banno/jha-wc/src/jha-tab-item/jha-tab-item";
import "@banno/jha-wc/src/cards/jha-card/jha-card";
import "@banno/jha-wc/src/buttons/jha-button/jha-button";
import "@banno/jha-wc/src/icons/jha-icon-warning-filled";
import "@banno/jha-wc/src/icons/jha-icon-circle-checkmark-filled";
import "./WorkflowGeneralInfoView";
import "./NotificationView";
import "./WorkflowStepsView";
import "./SchedulerView";
import "../../Components/Loader";
import {
  WorkflowType,
  NotificationType,
  WorkflowStepsType,
  FileInfoType,
  DEFAULT_WORKFLOW_TYPE_ODI,
} from "../../types/Workflow/WorkflowDataType";
import Cookies from "js-cookie";
import { Apis } from "../../utils/api-constants";
import { getWorkflowSaveErrorMessage } from "../../utils/getErrorMessage";
import { GlobalVariables, GlobalConstants } from "../../utils/constants";
import { showToast } from "@banno/jha-wc/src/js/utils/toast-util.js";
import { deleteRequest, getRequest, postRequest, putRequest } from "../../utils/jha-fetch";
import { routerConfig } from "../../routers";
import { stringComparison, getCurrentDateTimeInTimeZone, getTimeZoneIdentifier } from "../../utils/app-utils";
import { isGeneralInfoTabComplete, syncGeneralInfoValid } from "../../utils/workflow-general-info-valid";
import {
  formatWorkflowSaveProblems,
  workflowSaveInvalidBlankMessage,
} from "../../utils/workflow-save-validation";
import { formatWorkflowSchedulerNow } from "../../utils/datetime-display";
import { AppRouters } from "../../utils/app-router";
import { openJhftDialog } from "../../Components/JhftJhaDialog";
import {
  afterGeneralInfoLoad,
  applyWorkflowCancelBaselineDefaults,
  captureWorkflowCancelBaseline,
  isWorkflowCancelDirty,
  resolveGeneralInfoAutoFill,
} from "../../utils/workflow-cancel-dirty";
import {
  applyFileLocationAuthTypeIfSftpFtps,
  applyPushSftpAuthTypeToCredentialSourceFileInfo,
  cloneSecretValueOmitAuthType,
} from "../../utils/workflow-file-location-secret";
import { applyInstitutionUuidOutbound } from "../../utils/workflow-institution-step";
import { newWorkflowId } from "../../utils/workflow-id";
import { resolveWorkflowPathSegment } from "../../utils/workflow-source-location-path";
//import '@jack-henry/jh-ui/components/tooltip/tooltip.js';

@customElement("create-workflow-tab-view")
export class CreateWorkflowTabView extends routingMixin(LitElement) {
  constructor() {
    super();
  }

  @property({ type: Boolean }) isFilePatternValid = false;
  @property() activeTab = "page1";
  @property() sourceLocationPath = "";
  @property() sourceFolder = "";
  @property({ type: Object }) workflowData = { isEdit: false };
  @property({ type: Object }) filepattern = { TriggerFilePattern: ([] = []), DataFilePattern: ([] = []), isEdit: false, valid: false };
  @property({ type: Object }) schedulerData = { isRateDisabled: false, isCronDisabled: true };
  @property({ type: Array }) notification = [];
  @property({ type: Object })
  notificationData = {
    number: 1,
    messageType: "",
    notificationType: "",
    to: "",
    subject: "",
    template: "",
    added: false,
  };
  @property({ type: Array }) steps = [];
  @property({ type: Boolean }) workFlowDisable = true;
  /** ACME-1050: baseline after hydrate — see `workflow-cancel-dirty.ts` (do not latch dirty from tab events). */
  private _cancelBaseline: string | null = null;
  private _giDefaultsFolded = false;
  @property({ type: Object })
  workflow: WorkflowType = {
    WorkflowName: "",
    sourceLocationPath: "",
    BusinessUnitParticipant: "",
    DeleteFiles: "",
    DataFilePattern: [],
    TriggerFilePattern: [],
    Notification: [],
    status: "",
    Scheduler: {
      SchedulerName: "",
      Description: "",
      Expression: "",
      TimeZone: "",
      StartDate: "",
      StartTime: "",
      EndDate: "",
      EndTime: "",
    },
    workflowType: "",
    workflowSteps: [],
    TransferType: "",
  };

  @property({ type: Object }) sourceFileInfo: FileInfoType = {};
  @property({ type: Boolean }) apiLoading = false;
  @property() workflowResponse: any;

  static get is() {
    return "create-workflow-tab-view";
  }

  static readonly styles = css`
    #createWorkflowTab {
      padding: 24px;
      flex: 1;
      display: flex;
      flex-direction: column;
    }
    jha-card {
      padding: 24px;
      flex: 1;
      display: flex;
      flex-direction: column;
      margin-left: 0px;
      margin-right: 0px;
      overflow: hidden;
    }
    #tabContent {
      display: flex;
      flex-direction: column;
      flex: 1;
      overflow-y: scroll;
    }
    #backBtn {
      cursor: pointer;
      margin-right: 10px;
    }
    jha-tab-item > [icon] {
      margin-right: 8px;
      vertical-align: middle;
    }
    jha-icon-circle-checkmark-filled {
      fill: var(--jha-color-success);
    }
    jha-icon-warning-filled {
      fill: var(--jha-color-warning);
    }
  `;

  onSaveWorkflowCustomEvent(e) {
    this.workflowData = e.detail;
  }

  onSaveWorkflowPatternsEvent(e) {
    this.filepattern = e.detail;
    this.isFilePatternValid = e.detail.DataFilePattern.length > 0 && e.detail.TriggerFilePattern.length > 0;
  }

  unsavednotificationChanges(e) {
    this.notificationData = e.detail;
  }

  onSaveNotificationCustomEvent(e) {
    this.notification = e.detail;
  }

  onSaveStepsCustomEvent(e) {
    this.steps = e.detail.workflowStepsData;
    this.workflowData.DeleteFiles = e.detail.deleteFiles;
  }

  onSaveSchedulerEvent(e) {
    this.schedulerData = e.detail;
  }

  async onSaveWorkflowClick() {
    syncGeneralInfoValid(this.workflowData);
    let currentDateTime = null;
    let scheduledDateTime = null;
    if (this.schedulerData.StartDate && this.schedulerData.StartHour && this.schedulerData.StartMinute) {
      scheduledDateTime = new Date(
        `${this.schedulerData.StartDate}T${this.schedulerData.StartHour}:${this.schedulerData.StartMinute}`
      );
      currentDateTime = getCurrentDateTimeInTimeZone(getTimeZoneIdentifier(this.schedulerData.TimeZone));
      currentDateTime.setSeconds(0, 0);
    }
    if (this.workflowData.TransferType == undefined) {
      this.requestUpdate();
      showToast({
        message: formatWorkflowSaveProblems([
          { label: "Transfer Type", kind: "required", tab: "General Information" },
        ]),
        role: "danger",
        duration: GlobalVariables.TOAST_TIMEOUT,
      });
    } else if (
      stringComparison(this.workflowData.TransferType, "PUSH") &&
      (!this.workflowData.valid || this.filepattern.DataFilePattern.length <= 0 || this.filepattern.TriggerFilePattern.length <= 0)
    ) {
      this.requestUpdate();
      showToast({
        message: workflowSaveInvalidBlankMessage({
          workflowData: this.workflowData,
          filepattern: this.filepattern,
          includeScheduler: false,
        }),
        role: "danger",
        duration: GlobalVariables.TOAST_TIMEOUT,
      });
    } else if (
      stringComparison(this.workflowData.TransferType, "PULL") &&
      (!this.workflowData.valid ||
        this.filepattern.DataFilePattern.length <= 0 ||
        this.filepattern.TriggerFilePattern.length <= 0 ||
        !this.schedulerData.valid)
    ) {
      this.requestUpdate();
      showToast({
        message: workflowSaveInvalidBlankMessage({
          workflowData: this.workflowData,
          filepattern: this.filepattern,
          schedulerData: this.schedulerData,
          includeScheduler: true,
        }),
        role: "danger",
        duration: GlobalVariables.TOAST_TIMEOUT,
      });
    } else if (this.schedulerData.StartDate != undefined && scheduledDateTime < currentDateTime) {
      const formatedDateTime = formatWorkflowSchedulerNow(this.schedulerData.TimeZone);
      this.apiLoading = false;
      showToast({
        message: `Scheduler start datetime cannot be less than current datetime ${formatedDateTime}`,
        role: "danger",
        duration: GlobalVariables.TOAST_TIMEOUT,
      });
    } else {
      //steps
      if (this.steps.length > 0) {
        let workflowSteps = {
          FunctionName: "",
          StepName: "",
          DeleteSourceFile: false,
          FileMovePattern: [],
          DestinationFileInfo: {
            Name: "",
            Path: "",
            LocationType: "",
            StorageType: "",
            FileRename: {},
            BucketRename: "",
            SecretName: "",
            SecretValue: {},
          },
          SourceFileInfo: {
            Name: "",
            Path: "",
            LocationType: "",
            StorageType: "",
            FileRename: {},
            BucketRename: "",
            SecretName: "",
            SecretValue: {},
          },
          StepIndex: 0,
        };

        this.workflow.workflowSteps = [];
        if (stringComparison(this.workflowData.TransferType, "PUSH")) {
          for (let i = 0; i < this.steps.length; i++) {
            this.workflow.workflowSteps.push(JSON.parse(JSON.stringify(workflowSteps)));
            this.workflow.workflowSteps[i].StepName = this.steps[i].stepName;
            this.workflow.workflowSteps[i].FunctionName = this.steps[i].functionName;
            this.workflow.workflowSteps[i].DeleteSourceFile = stringComparison(this.steps[i].deleteSourceFile, "true") ? true : false;
            this.workflow.workflowSteps[i].StepIndex = this.steps[i].stepIndex;
            this.workflow.workflowSteps[i].FileMovePattern = this.steps[i].FileMovePattern;
            applyInstitutionUuidOutbound(this.workflow.workflowSteps[i], this.steps[i].institutionUuid);
            if (stringComparison(this.workflow.workflowSteps[i].FunctionName, "filedelete")) {
              this.workflow.workflowSteps[i].SourceFileInfo.Name = this.steps[i].name;
              if (this.steps[i].path != undefined || this.steps[i].path != null) {
                this.workflow.workflowSteps[i].SourceFileInfo.Path = stringComparison(this.steps[i].storageType, "amazons3")
                  ? this.workflowData.BusinessUnitParticipant.concat(this.steps[i].path)
                  : this.steps[i].path;
              }
              this.sourceFolder = this.steps[i].name;
              this.workflow.workflowSteps[i].SourceFileInfo.LocationType = this.steps[i].locationType;
              this.workflow.workflowSteps[i].SourceFileInfo.StorageType = this.steps[i].storageType;
              this.workflow.workflowSteps[i].SourceFileInfo.FileRename = this.steps[i].fileRename;
              this.workflow.workflowSteps[i].SourceFileInfo.BucketRename = this.steps[i].bucketRename;
              if (this.steps[i].storageType == "azure" || this.steps[i].storageType == "amazons3remote") {
                this.workflow.workflowSteps[i].DestinationFileInfo.SecretName = this.steps[i].secretName;
                this.workflow.workflowSteps[i].DestinationFileInfo.SecretValue = cloneSecretValueOmitAuthType(
                  this.steps[i].secretValue
                );
              } else {
                this.workflow.workflowSteps[i].SourceFileInfo.SecretName = this.steps[i].secretName;
                this.workflow.workflowSteps[i].SourceFileInfo.SecretValue = cloneSecretValueOmitAuthType(
                  this.steps[i].secretValue
                );
              }
              applyFileLocationAuthTypeIfSftpFtps(this.workflow.workflowSteps[i].SourceFileInfo, this.steps[i], "source");
              applyFileLocationAuthTypeIfSftpFtps(this.workflow.workflowSteps[i].DestinationFileInfo, this.steps[i], "destination");
            } else {
              this.workflow.workflowSteps[i].DestinationFileInfo.Name = this.steps[i].name;
              if (this.steps[i].path != undefined || this.steps[i].path != null) {
                this.workflow.workflowSteps[i].DestinationFileInfo.Path = this.steps[i].path;
              }
              this.workflow.workflowSteps[i].DestinationFileInfo.LocationType = this.steps[i].locationType;
              this.workflow.workflowSteps[i].DestinationFileInfo.StorageType = this.steps[i].storageType;
              this.workflow.workflowSteps[i].DestinationFileInfo.FileRename = this.steps[i].fileRename;
              this.workflow.workflowSteps[i].DestinationFileInfo.BucketRename = this.steps[i].bucketRename;

              if (this.steps[i].storageType == "azure" || this.steps[i].storageType == "amazons3remote") {
                this.workflow.workflowSteps[i].DestinationFileInfo.SecretName = this.steps[i].secretName;
                this.workflow.workflowSteps[i].DestinationFileInfo.SecretValue = cloneSecretValueOmitAuthType(
                  this.steps[i].secretValue
                );
              } else {
                this.workflow.workflowSteps[i].SourceFileInfo.SecretName = this.steps[i].secretName;
                this.workflow.workflowSteps[i].SourceFileInfo.SecretValue = cloneSecretValueOmitAuthType(
                  this.steps[i].secretValue
                );
              }
              applyFileLocationAuthTypeIfSftpFtps(this.workflow.workflowSteps[i].SourceFileInfo, this.steps[i], "source");
              applyFileLocationAuthTypeIfSftpFtps(this.workflow.workflowSteps[i].DestinationFileInfo, this.steps[i], "destination");
              applyPushSftpAuthTypeToCredentialSourceFileInfo(
                this.workflow.workflowSteps[i].SourceFileInfo,
                this.steps[i],
                this.steps[i].storageType
              );
            }
          }
        } else if (stringComparison(this.workflowData.TransferType, "PULL")) {
          for (let i = 0; i < this.steps.length; i++) {
            this.workflow.workflowSteps.push(JSON.parse(JSON.stringify(workflowSteps)));
            this.workflow.workflowSteps[i].StepName = this.steps[i].stepName;
            this.workflow.workflowSteps[i].FunctionName = this.steps[i].functionName;
            this.workflow.workflowSteps[i].DeleteSourceFile = stringComparison(this.steps[i].deleteSourceFile, "true") ? true : false;
            this.workflow.workflowSteps[i].StepIndex = this.steps[i].stepIndex;
            this.workflow.workflowSteps[i].FileMovePattern = this.steps[i].FileMovePattern;
            applyInstitutionUuidOutbound(this.workflow.workflowSteps[i], this.steps[i].institutionUuid);
            if (
              stringComparison(this.workflow.workflowSteps[i].FunctionName, "filedownload") ||
              stringComparison(this.workflow.workflowSteps[i].FunctionName, "filedelete")
            ) {
              this.workflow.workflowSteps[i].SourceFileInfo.Name = this.steps[i].name;
              if (this.steps[i].path != undefined || this.steps[i].path != null) {
                this.workflow.workflowSteps[i].SourceFileInfo.Path = this.steps[i].path;
              }
              this.sourceFolder = this.steps[i].name;
              this.workflow.workflowSteps[i].SourceFileInfo.LocationType = this.steps[i].locationType;
              this.workflow.workflowSteps[i].SourceFileInfo.StorageType = this.steps[i].storageType;
              this.workflow.workflowSteps[i].SourceFileInfo.FileRename = this.steps[i].fileRename;
              this.workflow.workflowSteps[i].SourceFileInfo.BucketRename = this.steps[i].bucketRename;
              this.workflow.workflowSteps[i].SourceFileInfo.SecretName = this.steps[i].secretName;
              this.workflow.workflowSteps[i].SourceFileInfo.SecretValue = cloneSecretValueOmitAuthType(
                this.steps[i].secretValue
              );
              applyFileLocationAuthTypeIfSftpFtps(this.workflow.workflowSteps[i].SourceFileInfo, this.steps[i], "source");
              applyFileLocationAuthTypeIfSftpFtps(this.workflow.workflowSteps[i].DestinationFileInfo, this.steps[i], "destination");
            } else {
              this.workflow.workflowSteps[i].DestinationFileInfo.Name = this.steps[i].name;
              if (this.steps[i].path != undefined || this.steps[i].path != null) {
                this.workflow.workflowSteps[i].DestinationFileInfo.Path = this.steps[i].path;
              }
              this.workflow.workflowSteps[i].DestinationFileInfo.LocationType = this.steps[i].locationType;
              this.workflow.workflowSteps[i].DestinationFileInfo.StorageType = this.steps[i].storageType;
              this.workflow.workflowSteps[i].DestinationFileInfo.FileRename = this.steps[i].fileRename;
              this.workflow.workflowSteps[i].DestinationFileInfo.BucketRename = this.steps[i].bucketRename;

              if (this.steps[i].storageType == "azure" || this.steps[i].storageType == "amazons3remote") {
                this.workflow.workflowSteps[i].DestinationFileInfo.SecretName = this.steps[i].secretName;
                this.workflow.workflowSteps[i].DestinationFileInfo.SecretValue = cloneSecretValueOmitAuthType(
                  this.steps[i].secretValue
                );
              } else {
                this.workflow.workflowSteps[i].SourceFileInfo.SecretName = this.steps[i].secretName;
                this.workflow.workflowSteps[i].SourceFileInfo.SecretValue = cloneSecretValueOmitAuthType(
                  this.steps[i].secretValue
                );
              }
              applyFileLocationAuthTypeIfSftpFtps(this.workflow.workflowSteps[i].SourceFileInfo, this.steps[i], "source");
              applyFileLocationAuthTypeIfSftpFtps(this.workflow.workflowSteps[i].DestinationFileInfo, this.steps[i], "destination");
              applyPushSftpAuthTypeToCredentialSourceFileInfo(
                this.workflow.workflowSteps[i].SourceFileInfo,
                this.steps[i],
                this.steps[i].storageType
              );
            }
          }
        }
      }
      //notification
      if (this.notification.length > 0) {
        let notifications = {
          messageType: "",
          notificationType: "",
          to: "",
          subject: "",
          template: "",
        };
        this.workflow.Notification = [];
        for (let i = 0; i < this.notification.length; i++) {
          this.workflow.Notification.push(JSON.parse(JSON.stringify(notifications)));
          this.workflow.Notification[i].to = this.notification[i].to;
          this.workflow.Notification[i].subject = this.notification[i].subject;
          this.workflow.Notification[i].messageType = this.notification[i].messageType;
          this.workflow.Notification[i].notificationType = this.notification[i].notificationType;
          this.workflow.Notification[i].template = this.notification[i].template;
        }
      } else {
        this.workflow.Notification = null;
      }
      if (this.schedulerData != undefined) {
        this.workflow.Scheduler.Description = this.schedulerData.Description;
        this.workflow.Scheduler.Expression = this.schedulerData.Expression;
        this.workflow.Scheduler.StartDate = this.schedulerData.StartDate;
        if (this.schedulerData.StartHour != undefined) {
          this.workflow.Scheduler.StartTime = `${this.schedulerData.StartHour}:${this.schedulerData.StartMinute}`;
        }
        this.workflow.Scheduler.EndDate = this.schedulerData.EndDate;
        this.workflow.Scheduler.EndTime = this.schedulerData.EndTime;
        this.workflow.Scheduler.TimeZone = this.schedulerData.TimeZone;
      } else {
        this.workflow.Scheduler = null;
      }
      //workflow
      if (!this.workflowData.WorkflowId) {
        this.workflowData.WorkflowId = newWorkflowId();
      }
      const pathSegment = resolveWorkflowPathSegment(
        this.workflowData.WorkflowId,
        this.workflowData.WorkflowName,
      );
      this.workflow.WorkflowId = this.workflowData.WorkflowId;
      this.workflow.BusinessUnitParticipant = this.workflowData.BusinessUnitParticipant;
      this.workflow.sourceLocationPath = stringComparison(this.workflowData.TransferType, "pull")
        ? "/" + pathSegment + "/"
        : this.workflowData.sourceLocationPath;
      this.workflow.TriggerFilePattern = stringComparison(this.workflowData.TransferType, "push")
        ? this.filepattern.TriggerFilePattern
        : this.filepattern.TriggerFilePattern.map((element) => "\\".concat("/*", element.replace("/", "\\/")));
      this.workflow.DataFilePattern = stringComparison(this.workflowData.TransferType, "push")
        ? this.filepattern.DataFilePattern
        : this.filepattern.DataFilePattern.map((element) => "\\".concat("/*", element.replace("/", "\\/")));
      this.workflow.TransferType = this.workflowData.TransferType;
      this.workflow.WorkflowName = this.workflowData.WorkflowName;
      this.workflow.status = "active";
      this.workflow.workflowType = DEFAULT_WORKFLOW_TYPE_ODI;
      this.workflow.DeleteFiles = stringComparison(this.workflowData.TransferType, "pull")
        ? true
        : this.workflowData.DeleteFiles == true
          ? true
          : false;
      await this.addWorkflowToDb(this.workflow);
    }
  }

  async addWorkflowToDb(request) {
    this.apiLoading = true;
    const response = await postRequest<WorkflowType>(Apis.ADD_WORKFLOW, request);
    if (response?.messageStatus === null) {
      this.apiLoading = false;
      showToast({
        message: "A new workflow has been created successfully.",
        role: "success",
        duration: GlobalVariables.TOAST_TIMEOUT,
      });
      const router = new Router(routerConfig);
      router.go("/workflows");
    } else if (response.details.length > 0) {
      this.apiLoading = false;
      const errMsg = getWorkflowSaveErrorMessage(response.details);
      showToast({
        message: errMsg,
        role: "danger",
        duration: GlobalVariables.TOAST_TIMEOUT,
      });
    } else {
      this.apiLoading = false;
      showToast({
        message: "Something went wrong, please try again.",
        role: "danger",
        duration: GlobalVariables.TOAST_TIMEOUT,
      });
    }
  }

  onBackClick() {
    const router = new Router(routerConfig);
    router.go("/workflows");
  }

  private cancelSnapshotInput() {
    return {
      workflowData: this.workflowData,
      filepattern: this.filepattern,
      notification: this.notification,
      steps: this.steps,
      schedulerData: this.schedulerData,
    };
  }

  /**
   * Fold the Business Admin BU auto-fill once General Info lookups have landed.
   * Call from Cancel as well as firstUpdated — otherwise Cancel after auto-fill
   * but before firstUpdated's fold reads as dirty with no user edit.
   * Fold the value the load wrote (`autoFilledBusinessUnitParticipant`), not live form state.
   * GI unmounts when the user leaves the tab — resolveGeneralInfoAutoFill still
   * sees the record loadLookups left on the shared workflowData object.
   */
  private foldGeneralInfoDefaults() {
    if (this._giDefaultsFolded) return;
    const gi = this.shadowRoot?.querySelector("workflow-general-info") as
      | {
        lookupsDone?: boolean;
        autoFilledBusinessUnitParticipant?: string;
      }
      | null
      | undefined;
    const { lookupsDone, autoFilled: filled } = resolveGeneralInfoAutoFill(this.workflowData, gi);
    if (!lookupsDone) return;
    this._giDefaultsFolded = true;
    if (filled !== undefined) {
      this._cancelBaseline = applyWorkflowCancelBaselineDefaults(this._cancelBaseline, {
        workflowData: { BusinessUnitParticipant: filled },
      });
    }
  }

  /** ACME-1050: true only after real user edits vs hydrate baseline. */
  private hasUnsavedChanges(): boolean {
    this.foldGeneralInfoDefaults();
    return isWorkflowCancelDirty(this._cancelBaseline, this.cancelSnapshotInput());
  }

  async onCancelClick() {
    // No change → no prompt (ACME-1050). Do not remove this gate.
    if (!this.hasUnsavedChanges()) {
      AppRouters.go("/workflows");
      return;
    }
    const result = await openJhftDialog({
      variant: "warning",
      title: "Unsaved Changes",
      message: "You have unsaved changes. Are you sure you want to leave without saving?",
      cancelLabel: "Stay",
      confirmLabel: "Leave Without Saving",
    });
    if (result === "confirm") {
      AppRouters.go("/workflows");
    }
  }

  async connectedCallback() {
    super.connectedCallback();
    if (!this.workflowData.WorkflowId) {
      this.workflowData.WorkflowId = newWorkflowId();
    }
    // Capture before General Info lookups: the form is already typable, and a null
    // baseline reads as clean. Fold the BU auto-fill when lookups land — do not recapture.
    this._cancelBaseline = captureWorkflowCancelBaseline(this.cancelSnapshotInput());
  }

  protected async firstUpdated() {
    await this.updateComplete;
    await afterGeneralInfoLoad(this);
    this.foldGeneralInfoDefaults();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  render() {
    return html`
      ${this.apiLoading ? html`<circle-loader></circle-loader>` : undefined}
      <div id="createWorkflowTab">
        <h1>
          <span>Add Workflow</span>
        </h1>
        <jha-card>
          <jha-tab bordered>
            <jha-tab-item
              data-auto-id="generalInfoTab"
              ?active=${stringComparison(this.activeTab, "page1")}
              @click=${() => {
        this.activeTab = "page1";
        this.workFlowDisable = true;
      }}>
              General Information
              ${isGeneralInfoTabComplete(this.workflowData)
        ? html`<jha-icon-circle-checkmark-filled icon></jha-icon-circle-checkmark-filled>`
        : html` <jha-icon-warning-filled icon></jha-icon-warning-filled> `}
            </jha-tab-item>
            <jha-tab-item
              data-auto-id="filePatternTab"
              ?active=${stringComparison(this.activeTab, "page2")}
              @click=${() => {
        this.activeTab = "page2";
        this.workFlowDisable = true;
      }}>
              File Patterns
              ${this.isFilePatternValid
        ? html`<jha-icon-circle-checkmark-filled icon></jha-icon-circle-checkmark-filled>`
        : html` <jha-icon-warning-filled icon></jha-icon-warning-filled> `}
            </jha-tab-item>
            <jha-tab-item
              data-auto-id="notificationTab"
              ?active=${stringComparison(this.activeTab, "page3")}
              @click=${() => {
        this.activeTab = "page3";
        this.workFlowDisable = true;
      }}>
              Notifications
            </jha-tab-item>
            <jha-tab-item
              data-auto-id="workflowStepsTab"
              ?active=${stringComparison(this.activeTab, "page4")}
              @click=${() => {
        this.activeTab = "page4";
        stringComparison(this.workflowData.TransferType, "PUSH")
          ? (this.workFlowDisable = false)
          : (this.workFlowDisable = true);
      }}>
              Workflow Steps
            </jha-tab-item>
            ${stringComparison(this.workflowData.TransferType, "PULL")
        ? html` <jha-tab-item
                  data-auto-id="schedulerTab"
                  ?active=${stringComparison(this.activeTab, "page5")}
                  @click=${() => {
            this.activeTab = "page5";
            this.workFlowDisable = false;
          }}>
                  Scheduler${this.schedulerData.valid
            ? html`<jha-icon-circle-checkmark-filled icon></jha-icon-circle-checkmark-filled>`
            : html` <jha-icon-warning-filled icon></jha-icon-warning-filled>`}
                </jha-tab-item>`
        : undefined}
          </jha-tab>
          <div id="tabContent">
            ${stringComparison(this.activeTab, "page1")
        ? html`<workflow-general-info
                  @onWorkflowNameChange=${this.onSaveWorkflowCustomEvent}
                  .formData=${this.workflowData}></workflow-general-info>`
        : undefined}
            ${stringComparison(this.activeTab, "page2")
        ? html`<file-pattern-view
                  @onFilePatternChange=${this.onSaveWorkflowPatternsEvent}
                  .formData=${this.filepattern}></file-pattern-view>`
        : undefined}
            ${stringComparison(this.activeTab, "page3")
        ? html`<notification-view
                  @onformNotValid=${this.unsavednotificationChanges}
                  .formData=${this.notificationData}
                  @onNotificationChange=${this.onSaveNotificationCustomEvent}
                  .notificationList=${this.notification}></notification-view>`
        : undefined}
            ${stringComparison(this.activeTab, "page4")
        ? html`<workflow-steps-view
                  @onStepsChange=${this.onSaveStepsCustomEvent}
                  .workflowStepsData=${this.steps}
                  .formData=${this.workflowData}>
                </workflow-steps-view>`
        : undefined}
            ${stringComparison(this.activeTab, "page5") && stringComparison(this.workflowData.TransferType, "PULL")
        ? html`<p>
                  <scheduler-view @onSchedulerChange=${this.onSaveSchedulerEvent} .formData=${this.schedulerData}> </scheduler-view>
                </p>`
        : undefined}
          </div>
          <div id="actionBtns">
            <jha-tooltip top text="Click to save and exit.">
              <jha-button data-auto-id="saveWorkflowBtn" @click=${this.onSaveWorkflowClick} sync ?disabled=${this.workFlowDisable}
                >Save Workflow</jha-button>
              </jha-tooltip
            >
            <jha-tooltip top text="Click to cancel and exit without saving.">
              <jha-button data-auto-id="cancelWorkflowBtn" tertiary sync @click=${this.onCancelClick}>Cancel</jha-button>
            </jha-tooltip>
          </div>
        </jha-card>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "create-workflow-tab-view": CreateWorkflowTabView;
  }
}